import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import RegisterForm from "../../components/Onboarding/RegisterForm";
import BusinessDescription from "../../components/Onboarding/BusinessDescription";
import BasicInfo from "../../components/Onboarding/BasicInfo";
import CurrentPractice from "../../components/Onboarding/CurrentPractice";
import { useOnboarding } from "../../contexts/onboarding";
import Education from "../../components/Onboarding/Education";
import ProfessionalLicense from "../../components/Onboarding/ProfessionalLicense";
import Availability from "../../components/Onboarding/Availability";
import ClientServed from "../../components/Onboarding/ClientServed";
import Subsciption from "../../components/Onboarding/Subsciption";
import { group_practice, promoURL, treatment_program, independent_mental_health_professional, referring_physician } from "../../constants/common";
import TreatmentProgramProfile from "../../components/Onboarding/TreatmentProgramProfile";
import ServicesAvailable from "../../components/Onboarding/ServicesAvailable";
import { useSearchParams } from "react-router-dom";
import "./style.css";
import { validatePromoCity } from "../../utils/helper";
import Loader from "../../components/Loader";
// import { fetchCurrentCity } from "../../googleAPI";

const Onboarding = () => {
  const { step, onboardingState } = useOnboarding();
  const isTreatmentProgram = [treatment_program, group_practice].includes(onboardingState.account_type);
  const needsProfessionalLicense = [independent_mental_health_professional, referring_physician].includes(onboardingState.account_type);

  const [searchParams] = useSearchParams();
  const payment = searchParams.get("payment");
  const TP = searchParams.get("TP");

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      localStorage.removeItem('onboardingStep');
      localStorage.removeItem('onboardingData');
      window.location.reload();
    }, 10 * 60 * 1000);

    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box>
      {step > 1 && step < (needsProfessionalLicense ? 9 : 8) && (
        <div className="alignmentText">
          <Typography variant="h3" mb={0.5} textTransform="capitalize">
            {isTreatmentProgram && step > 3 ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <Avatar
                  src={onboardingState.facility_image}
                  sx={{
                    width: 33,
                    height: 33,
                  }}
                />
                {onboardingState.facility_name}
              </Box>
            ) : (
              `Welcome, ${onboardingState.first_name}!`
            )}
          </Typography>
          <Typography variant="body2" mb={1} color="text.secondary">
            {isTreatmentProgram && step > 3
              ? "Let's start your business profile"
              : "Let's start your profile"}
          </Typography>
          {step > 1 && step < (needsProfessionalLicense ? 9 : 8) ? (
            <div className="onboard-progress-bar">
              {new Array(needsProfessionalLicense ? 8 : 7).fill("")?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      step > index + 1
                        ? "active-onboard-progress-bar-item"
                        : "onboard-progress-bar-item"
                    }
                  ></div>
                );
              })}
            </div>
          ) : null}
        </div>
      )}

      {step === 1 && <RegisterForm />}

      {step === 2 && <BusinessDescription payment={payment} TP={TP} />}

      {isTreatmentProgram ? (
        <>
          {step === 3 && <TreatmentProgramProfile />}

          {step === 4 && <ServicesAvailable />}

          {step === 5 && <ClientServed />}

          {step === 6 && <Availability />}
        </>
      ) : (
        <>
          {step === 3 && <BasicInfo />}

          {step === 4 && <CurrentPractice />}

          {step === 5 && <Education />}

          {step === 6 && needsProfessionalLicense && <ProfessionalLicense />}

          {step === (needsProfessionalLicense ? 7 : 6) && <Availability />}

          {step === (needsProfessionalLicense ? 8 : 7) && <ClientServed />}

          {step === (needsProfessionalLicense ? 9 : 8) && <Subsciption />}
        </>
      )}
    </Box>
  );
};

export default Onboarding;
